const CountryDataReference = `
  fragment CountryDataReference on CountryDataReference {
    label
    value
  }
`
export default CountryDataReference
